import { Link } from "react-router-dom";
import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 3rem;
`

export const Section = styled.section`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
`

export const SectionTitle = styled.h2`
  font-weight: 700;
  font-size: 1.4rem;
`

export const SectionElements = styled.ul`
  list-style: none;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 2rem;
  box-sizing: border-box;
`

export const StyledLink = styled(Link)`
  text-decoration: none;
  margin: 0;
  padding: 0;
  color: inherit;
`

export const SectionElement = styled.li`
  background-color: #fff;
  padding: 1rem;
  border-radius: 1rem;
  cursor: pointer;
  user-select: none;
  display: flex;
  flex-direction: column;
  gap: .8rem;
  position: relative;

  &:hover{
    background-color: #FAFAFA;
  }
`

export const ElementName = styled.h2`
  font-weight: 700;
  font-size: 1.1rem;
`

export const ElementImage = styled.img`
  width: 1.8rem;

  &.arrow{
    position: absolute;
    right: 1rem;
    width: .6rem;
    top: 50%;
    transform: translateY(-50%);
  }
`